const state = {
  // ----used----

  packageVersion: process.env.PACKAGE_VERSION || '0',
 
  //----unused----
  // global login, data and server setup on initial login
  loggedIn: false,
  loginDialog: false,
  statusMsg: '(c) 2020 Entrinsia, Inc.',
  accessToken: null,
  loggedinUser: {},
  currentOrg: {},
  orgDefaults: {},
  menuItems: [],
  alert: { show: false, msg: '', color: 'black' },
  
  translator: [],
  translatorTableNames: [],
  sensorData: [],
 
  language: 'en',
  phraseMap: [],
  printers: [],
  printerType: '',
  genericTableName: '',
  printerObj: null,
  inputDevices: null,
  moreServices: null,

  kiosk: false,
  dark: true, //theme
  theme: 'Standard', //palette
  themeMenu: false,
  fullScreen: false,
  logo: '',
  debug: 0,
  routeLoading: false,

  tableCache: {},
  objectCache: {},

  // global table CRUD
  tableUseSSPagination: false,
  templateTableName: '',
  tableHeaders: [],
  tableRows: [],
  tableTitle: '',
  tableName: '',
  tableSelectableRows: false, // create check marks for table row select
  tableShowTooltips: true,
  tableShowEditButtons: true,
  tableShowDeleteButtons: true,
  tableShowMoreButtons: false,
  tableShowAddButton: true,
  tableAddButtonName: 'add',
  tableLoading: false,
  tableSelectedRows: [],
  
  tableMoreClickFunction: null,
  tableDuplicateFunction: null,
  tableIsSortable: false,
  tableSaveDragSort: null,
  tableAllowExpansion: false, // whether to allow row expansion
  tableExpandedRows: {}, // keep track of expanded rows
  tableHideActions: false,
  clickAction: {},

  // table: obsolete, get rid of these after cleanup
  listItems: [],

  currentReport: '',
  report: {},

  // fields for simple table, isolated from main table
  stTableTitle: '',
  stTableHeaders: [],
  stTableRows: [],
  stEditables: [],
  stTableName: '',
  stTableLoading: false,
  stRowClickFunction: null,
  stRowAddFunction: null,

  // stepper component open/close
  stepperOpen: false,

  // all fields to use for embedded Dialog component
  dialogOpen: false, // to open and close the main dialog attached to table
  editables: [],
  dialogTitle: 'Dialog', // title of dialog
  dialogDefaultItem: {},
  dialogEditedItem: {}, // the edited Item
  dialogGetRemote: null, // the function to be called if a field is marked remote callable
  dialogRemoteTitle: 'REMOTE',
  dialogEditIndex: -1,
  dialogSaveCallback: null, // function to callback when saving from dialog
  dialogCloseCallback: null,
  dialogSubEdit: false,
  dialogSavedState: {},
  dialogStateIsSaved: false,
  dialogExpandedId: null,
  dialogIsFullPage: true,
  dialogFunctions: {},
  dialogErrors: {},
  dialogExcludes: [],
  dialogMainComponent: 'generic-dialog',
  dialogCustomComponent: false,

  arrayEditTable: false, // if this is true then the table being edited is secondary array Table
  // arrayEditDialog: false, // if true the dialog is that of an array edit
  arrayProps: {},
  arrayItem: {},
  arrayHeader: {},
  arraySavedItem: null,
  dialogFooter: true,
  arrayEditSelector: -2,
  // selectRowToEdit: false,

  // Second Dialog Component Options
  secondDialogEnabled: false,
  secondDialogComponent: null,

  // mqtt
  mqttClient: null,
  lastSensorReading: [],
  mqttAuthorized: false,

  // function hooks
  dialogDeleteCallback: null,
  callbackNew: null,

  //shopping cart
  shoppingCartList: [],
  shoppingCartVisible: false,
  shoppingCartItems: 0,
  shoppingCartClicked: null,

  // to save and restore state
  savedTableState: {},
  savedDialogState: {},

  mqttTableUpdated: '',
  cacheTablesPreloaded: false,

  //metrc training mode
  training: false,

  // logging function
  elog: null,

  //indicate whether this is loaded from webview
  webview: false
}

export default state


